"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { getT } from "@local/i18n/src/t";
import { DEFAULT_LANGUAGE, type Language } from "@local/i18n/src/languages";
import { reviews as reviewsCatalog } from "@local/i18n/src/catalogs/reviews";
import { ReviewCard } from "./ReviewCard";
interface Review {
  id: string;
  name: string;
  avatar?: string | null;
  rating: number;
  content: string;
  date: string;
  sourceUrl?: string;
}
interface SenjaReviewsClientProps {
  reviews: Review[];
  initialDisplayCount?: number;
  language?: Language;
}
export const SenjaReviewsClient = t0 => {
  const $ = _c(17);
  const {
    reviews,
    initialDisplayCount: t1,
    language: t2
  } = t0;
  const initialDisplayCount = t1 === undefined ? 9 : t1;
  const language = t2 === undefined ? DEFAULT_LANGUAGE : t2;
  const t = getT(language, {
    reviews: reviewsCatalog
  });
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);
  let handleLoadMore;
  let hasMore;
  let t3;
  let t4;
  if ($[0] !== displayCount || $[1] !== language || $[2] !== reviews) {
    const visibleReviews = reviews.slice(0, displayCount);
    hasMore = displayCount < reviews.length;
    let t5;
    if ($[7] !== reviews.length) {
      t5 = () => {
        setDisplayCount(prev => Math.min(prev + 9, reviews.length));
      };
      $[7] = reviews.length;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    handleLoadMore = t5;
    t3 = "grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3";
    let t6;
    if ($[9] !== language) {
      t6 = review => <ReviewCard key={review.id} testimonial={review} language={language} />;
      $[9] = language;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t4 = visibleReviews.map(t6);
    $[0] = displayCount;
    $[1] = language;
    $[2] = reviews;
    $[3] = handleLoadMore;
    $[4] = hasMore;
    $[5] = t3;
    $[6] = t4;
  } else {
    handleLoadMore = $[3];
    hasMore = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = hasMore && <div className="flex justify-center pt-2"><button onClick={handleLoadMore} className="rounded border border-gray-200 bg-white px-2 py-1 text-sm text-gray-700 shadow-sm transition-colors hover:bg-gray-50">{t("reviews.loadMore")}</button></div>;
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};